export default "/images/logo.png?2abf6cb9c37bfe5768098412ae129ee4";